"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

// Wordmark set in the display serif with a gold terminal dot (DESIGN.md §9 logo refresh —
// typographic treatment; a full mark/logotype remains an owner design deliverable).
const Wordmark = () => (
	<span className="font-serif text-xl font-medium tracking-tight text-mg-black sm:text-2xl">
		micrographer<span className="text-mg-gold-deep">.</span>
	</span>
);

export const Logo = () => {
	const pathname = usePathname();

	// On the homepage the wordmark is the page's h1; elsewhere it's a link home.
	if (pathname === "/") {
		return (
			<h1 className="flex items-center" aria-label="homepage">
				<Wordmark />
			</h1>
		);
	}
	return (
		<Link className="flex items-center" aria-label="homepage" href="/">
			<Wordmark />
		</Link>
	);
};
